import * as React from 'react';
import { ProductInterface } from '../../../Model/Product';
import { ObjectUtility } from '../../../Service/ObjectUtility';
import { Trans } from '../../Trans';
import { AbstractRow } from '../AbstractRow';
import { AttributeCell } from '../AttributeCell';
import { FinderImage } from '../FinderImage';
import { HeadlineCell } from '../HeadlineCell';
import { MiscCell } from '../MiscCell';
import { WatchlistCell } from '../WatchlistCell';

export class WebGuideAccessoriesRow extends AbstractRow {
    public renderCells() {
        const product = this.props.product;

        return <>
            <td><FinderImage product={product} dontLink={true} attr="Bild_Basisartikel"/></td>
            <AttributeCell product={product} dontLink={true} attr="@parent.Produktgruppenbeschreibung_kurz"/>
            <AttributeCell product={product} dontLink={true} attr="products">
                <h4><Trans>Produkte</Trans></h4>
                {this.connectedProducts(product)}
            </AttributeCell>
            <MiscCell product={product}
                      datasheetAttr={'@parent.Datenblatt'}
                      manualAttr={'@parent.Bedienungsanleitung'}/>
        </>;
    }

    protected renderHeadline(product: ProductInterface): JSX.Element {
        return <>
            <HeadlineCell colSpan={3} product={product} attr="name" dontLink={true}>
                {product.parent ? product.parent.name : ''} {product.name}
            </HeadlineCell>
            <WatchlistCell product={product}/>
        </>;
    }

    private connectedProducts(product: ProductInterface): string | null {
        if (product.parent && product.parent.relations) {
            return ObjectUtility.unique(product.parent.relations.map(p => p.name)).join(', ');
        } else {
            return null;
        }
    }
}
